import React, { useEffect, useState } from 'react';
import { supabase } from '../supabase';

export default function Banners() {
  const [banners, setBanners] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({ title: '', subtitle: '', image_url: '', action_url: '', color: '#2ECC71' });

  useEffect(() => { fetchBanners(); }, []);

  const fetchBanners = async () => {
    setLoading(true);
    const { data } = await supabase.from('banners').select('*').order('created_at', { ascending: false });
    if (data) setBanners(data);
    setLoading(false);
  };

  const createBanner = async () => {
    if (!form.title) { alert('Введите заголовок'); return; }
    await supabase.from('banners').insert({
      title: form.title,
      subtitle: form.subtitle,
      image_url: form.image_url,
      action_url: form.action_url,
      color: form.color,
      is_active: true,
    });
    setShowCreate(false);
    setForm({ title: '', subtitle: '', image_url: '', action_url: '', color: '#2ECC71' });
    fetchBanners();
  };

  const toggleBanner = async (id: number, is_active: boolean) => {
    await supabase.from('banners').update({ is_active: !is_active }).eq('id', id);
    fetchBanners();
  };

  const deleteBanner = async (id: number) => {
    if (!window.confirm('Удалить баннер?')) return;
    await supabase.from('banners').delete().eq('id', id);
    fetchBanners();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={s.title}>🖼️ Баннеры</h1>
        <button style={s.btn} onClick={() => setShowCreate(!showCreate)}>
          {showCreate ? 'Отмена' : '+ Создать баннер'}
        </button>
      </div>

      {showCreate && (
        <div style={s.card}>
          <h3 style={{ marginBottom: 16 }}>Новый баннер</h3>
          <div style={s.row}>
            <div style={s.field}>
              <label style={s.label}>Заголовок *</label>
              <input style={s.input} placeholder="Новые рецепты!" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} />
            </div>
            <div style={s.field}>
              <label style={s.label}>Подзаголовок</label>
              <input style={s.input} placeholder="Попробуйте что-то новое" value={form.subtitle} onChange={e => setForm({ ...form, subtitle: e.target.value })} />
            </div>
          </div>
          <div style={s.row}>
            <div style={s.field}>
              <label style={s.label}>URL изображения</label>
              <input style={s.input} placeholder="https://..." value={form.image_url} onChange={e => setForm({ ...form, image_url: e.target.value })} />
            </div>
            <div style={s.field}>
              <label style={s.label}>Цвет фона</label>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <input type="color" value={form.color} onChange={e => setForm({ ...form, color: e.target.value })} style={{ width: 50, height: 40, borderRadius: 8, border: '1px solid #eee', cursor: 'pointer' }} />
                <input style={{ ...s.input, flex: 1 }} value={form.color} onChange={e => setForm({ ...form, color: e.target.value })} />
              </div>
            </div>
          </div>
          <div style={s.field}>
            <label style={s.label}>Ссылка при нажатии</label>
            <input style={s.input} placeholder="/recipes или https://..." value={form.action_url} onChange={e => setForm({ ...form, action_url: e.target.value })} />
          </div>

          {form.title && (
            <div style={{ ...s.preview, backgroundColor: form.color }}>
              <div style={s.previewTitle}>{form.title}</div>
              {form.subtitle && <div style={s.previewSubtitle}>{form.subtitle}</div>}
            </div>
          )}

          <button style={{ ...s.btn, marginTop: 16 }} onClick={createBanner}>💾 Создать</button>
        </div>
      )}

      {loading ? <p>Загрузка...</p> : banners.length === 0 ? (
        <div style={s.empty}>Баннеров нет</div>
      ) : (
        <div style={s.bannerList}>
          {banners.map(b => (
            <div key={b.id} style={s.bannerItem}>
              <div style={{ ...s.bannerPreview, backgroundColor: b.color || '#2ECC71' }}>
                <div style={s.previewTitle}>{b.title}</div>
                {b.subtitle && <div style={s.previewSubtitle}>{b.subtitle}</div>}
              </div>
              <div style={s.bannerInfo}>
                <div style={s.bannerTitle}>{b.title}</div>
                {b.action_url && <div style={s.bannerUrl}>{b.action_url}</div>}
                <div style={s.bannerActions}>
                  <span style={{ ...s.badge, backgroundColor: b.is_active ? '#d5f5e3' : '#f5f5f5', color: b.is_active ? '#2ECC71' : '#aaa' }}>
                    {b.is_active ? '✅ Активен' : '⏸ Скрыт'}
                  </span>
                  <button style={s.btnSmall} onClick={() => toggleBanner(b.id, b.is_active)}>
                    {b.is_active ? 'Скрыть' : 'Показать'}
                  </button>
                  <button style={{ ...s.btnSmall, backgroundColor: '#e74c3c' }} onClick={() => deleteBanner(b.id)}>Удалить</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  title: { fontSize: 24, fontWeight: 700, color: '#222', margin: 0 },
  card: { backgroundColor: '#fff', borderRadius: 12, padding: 24, marginBottom: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.06)', border: '1px solid #eee' },
  row: { display: 'flex', gap: 16, marginBottom: 12 },
  field: { flex: 1, display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 12 },
  label: { fontSize: 13, fontWeight: 600, color: '#555' },
  input: { padding: '10px 14px', borderRadius: 8, border: '1px solid #eee', fontSize: 14, outline: 'none' },
  btn: { backgroundColor: '#2ECC71', color: '#fff', border: 'none', borderRadius: 10, padding: '10px 20px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  preview: { borderRadius: 12, padding: 20, marginTop: 12 },
  previewTitle: { fontSize: 18, fontWeight: 700, color: '#fff' },
  previewSubtitle: { fontSize: 13, color: 'rgba(255,255,255,0.8)', marginTop: 4 },
  empty: { textAlign: 'center', color: '#aaa', padding: 40, backgroundColor: '#fff', borderRadius: 12 },
  bannerList: { display: 'flex', flexDirection: 'column', gap: 12 },
  bannerItem: { backgroundColor: '#fff', borderRadius: 12, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', display: 'flex' },
  bannerPreview: { width: 200, padding: 20, flexShrink: 0 },
  bannerInfo: { padding: 20, flex: 1 },
  bannerTitle: { fontSize: 16, fontWeight: 600, color: '#222', marginBottom: 4 },
  bannerUrl: { fontSize: 13, color: '#888', marginBottom: 12 },
  bannerActions: { display: 'flex', alignItems: 'center', gap: 8 },
  badge: { padding: '4px 10px', borderRadius: 20, fontSize: 12, fontWeight: 500 },
  btnSmall: { padding: '6px 12px', backgroundColor: '#2ECC71', color: '#fff', border: 'none', borderRadius: 6, fontSize: 12, cursor: 'pointer' },
};